import React, {Fragment, FunctionComponent} from 'react'
import {CloseIcon, MapMarkerIcon, MapMarkerIconNoRating, StarFilledIcon} from "@App/Components/common/Icons";
import {Garage, Service} from "@App/types";
import {useDates} from "@App/hooks/useDates";
import {useAssetUrl} from "@App/hooks/useAssetUrl";
import {
    GarageIsBookable,
    GarageShouldDisplayMapmarkerNoRating,
    GarageShouldDisplayMapmarkerWithRating
} from "@App/utils/conditionals/garages";
import {ServiceShouldDisplayReviews} from "@App/utils/conditionals/services";


type GarageMapMarkerProps = {
    garage: Garage
    service: Service
    open: boolean
    onClick: (garage: Garage) => void
    onToggle: (garage: Garage, open: boolean) => void
    lat: number,
    lng: number
}

export const GarageMapMarker: FunctionComponent<GarageMapMarkerProps> = ({garage, service, open, onClick, onToggle}: GarageMapMarkerProps)  => {

    const {formatShortDate} = useDates()
    const {url} = useAssetUrl()

    const garageRatingOutOfFive = (rating, fraction) => {
       return ((rating / 100) * 5).toFixed(fraction).replace('.', ',')
    }
    return (
        <div className={"cursor-pointer transition-all duration-400"}>

            <div
                className={`z-10 cursor-auto shadow bg-white w-screen md:w-80 fixed md:absolute left-[-50%] md:left-0 bottom-[15vh] md:bottom-3 p-3 ${open ? "show" : "hidden"}`}>
                <div className="grid gap-4 grid-cols-5">
                    <div className={"col-span-2"}>

                        {!!garage.cover_image
                            ? <img src={url + "/storage/" + garage.cover_image}
                                   className={"w-full h-auto mb-3"} alt=""
                            />
                            : <div
                                className={'flex items-center justify-center text-center text-neutral-700 font-serif font-bold bg-neutral-300 w-full h-2/3 min-h-[90px] lg:min-h-min mb-2'}>
                                {organization.name}
                                <br/>
                                Service-Standort
                            </div>
                        }
                        {GarageIsBookable(garage) && (
                            <button className={"bg-primary text-white px-4 py-2 w-full"}
                                onClick={() => onClick(garage)}>Termin wählen
                            </button>
                        )}
                    </div>
                    <div className={"col-span-3"}>
                        <div className="flex justify-between mb-3">
                            <div className="text-xl">
                                {garage.name}
                            </div>
                            <div onClick={() => onToggle(garage, false)}>
                                <CloseIcon/>
                            </div>
                        </div>
                        {GarageIsBookable(garage) && (
                            <Fragment>
                            {garage.rating && ServiceShouldDisplayReviews(service) &&(
                                    <div className={'flex mb-3'}>
                                        <Fragment>
                                            <StarFilledIcon/>
                                            <p>{garageRatingOutOfFive(garage.rating, 2)}</p>
                                        </Fragment>

                                    </div>
                                )}
                                <div className={'font-bold'}>
                                    Nächster
                                    Termin: {garage.available_days.length > 0 ? formatShortDate(garage.available_days[0].available_at) : 'kA'}
                                </div>
                            </Fragment>
                        )}
                        {!GarageIsBookable(garage) && garage.street &&(
                            <div className={'font-bold'}>
                                <p>{garage.street}, {garage.postcode} {garage.city}</p>
                            </div>
                            )}
                    </div>
                </div>
            </div>
            {GarageShouldDisplayMapmarkerNoRating(garage, service) && (
                <MapMarkerIconNoRating distance={garage.distance} clicked={open}
                                       onClick={() => onToggle(garage, true)}></MapMarkerIconNoRating>
            )}

            {GarageShouldDisplayMapmarkerWithRating(garage, service) && (
                <MapMarkerIcon distance={garage.distance} rating={garageRatingOutOfFive(garage.rating, 1)} clicked={open}
                               onClick={() => onToggle(garage, true)}></MapMarkerIcon>
            )}

        </div>
    )
}
